import BaseStore from './BaseStore'

export class InformeeStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'informees'
  }
}

export default new InformeeStore()


// WEBPACK FOOTER //
// ./src/stores/InformeeStore.js